import React from "react";
import LegalContentPage from "./legal_content_page";
import type { ContentItem } from "./legal_content_page";

const termsOfUseText: ContentItem[] = [
  {
    type: "heading",
    text: "Version 1.0",
  },
  {
    type: "paragraph",
    text: "We're finalizing our Terms of Use. The full terms will be published here shortly — please check back soon.",
  },
];

const TermsOfUsePage: React.FC = () => {
  return <LegalContentPage title="Terms of Use" content={termsOfUseText} />;
};

export default TermsOfUsePage;
